<mat-form-field class="w-full" subscriptSizing="dynamic">
  <mat-label>{{ label() }}</mat-label>
  <input
    [formControl]="control()"
    [type]="type()"
    [placeholder]="placeholder()"
    [readonly]="readonly()"
    [maxlength]="maxlength()"
    (input)="checkPasswordStrength()"
    (focus)="onFocus()"
    (blur)="onBlur()"
    matInput
    [id]="id()"
    autocomplete="new-password"
    #passwordField
  />
  <button
    (click)="
      passwordField.type === 'password' ? (passwordField.type = 'text') : (passwordField.type = 'password')
    "
    mat-icon-button
    type="button"
    matSuffix
  >
    @if (passwordField.type === 'password') {
      <mat-icon>visibility</mat-icon>
    }
    @if (passwordField.type === 'text') {
      <mat-icon>visibility_off</mat-icon>
    }
  </button>
  @if (control().hasError('required')) {
    <mat-error> Le mot de passe est requis </mat-error>
  } @else if (control().hasError('maxlength')) {
    <mat-error> Le mot de passe est trop long </mat-error>
  } @else if (control().hasError('minlength')) {
    <mat-error> Le mot de passe est trop court </mat-error>
  } @else if (control().hasError('weakPassword')) {
    <mat-error> Le mot de passe n'est pas assez fort </mat-error>
  }
</mat-form-field>

@if (showPasswordStrength() && (isFocused() || control().value)) {
  <ul class="password-checklist">
    <li [class.valid]="hasRightLength">
      @if (hasRightLength) {
        ☑️
      } @else {
        ❌
      }
      Entre 8 et {{ this.maxlength() }} caractères
    </li>
    <li [class.valid]="hasLowercase">
      @if (hasLowercase) {
        ☑️
      } @else {
        ❌
      }
      Au moins une lettre minuscule
    </li>
    <li [class.valid]="hasUppercase">
      @if (hasUppercase) {
        ☑️
      } @else {
        ❌
      }
      Au moins une majuscule
    </li>
    <li [class.valid]="hasSpecialChar">
      @if (hasSpecialChar) {
        ☑️
      } @else {
        ❌
      }
      Au moins un caractère spécial
    </li>
    <li [class.valid]="hasUpperOrNumber">
      @if (hasUpperOrNumber) {
        ☑️
      } @else {
        ❌
      }
      Au moins une lettre majuscule ou un chiffre
    </li>
  </ul>
}
